import { Button } from 'core-components/library/button'

export const AccessProblemHome = () => {
  return (
    <Button size={'md'} icon={'kbase kbase-home'} to={'/'}>
      RETURN HOME
    </Button>
  )
}
